import { Flex, Text } from "@chakra-ui/react";

import { useColor } from "@/styles/useColor";

interface ConversionRateDisplayProps {
  sellTokenSymbol: string;
  buyTokenSymbol: string;
  conversionRate: number;
  fiatValue: string;
}

export const ConversionRateDisplay = ({
  sellTokenSymbol,
  buyTokenSymbol,
  conversionRate,
  fiatValue,
}: ConversionRateDisplayProps) => {
  const color = useColor();

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Text color={color("600")}>
        1 {buyTokenSymbol} = {conversionRate.toFixed(6)} {sellTokenSymbol} ({fiatValue})
      </Text>
    </Flex>
  );
};
